// extracted by mini-css-extract-plugin
export default {"cellContent":"CashDeskTable_cellContent__1Ubil"};